import { getParam } from '../helpers/parameters'

export const attachBearerToken = async requestConfig => {
  const academyApiToken = await getParam('academyApiToken')
  return {
    ...requestConfig,
    headers: { Authorization: `Bearer ${academyApiToken}` }
  }
}



// WEBPACK FOOTER //
// ./src/services/attach-bearer-token.js